export default "__VITE_ASSET__CM0bzm3L__"